import * as React from 'react';
import { Route, Routes as RoutesSwitch } from 'react-router-dom';
import { ENV } from '../../../env';
import { observer } from 'mobx-react';
import { Routes, useJourneyNavigation } from '../../../routes';
import { PageHeadingWidget } from '../../../widgets/page/PageHeadingWidget';
import { ProfilePageWidget } from '../../../widgets/page/ProfilePageWidget';
import { ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { styled } from '../../../theme';
import { ConfigureMFADialogLayer } from './mfa/ConfigureMFADialogLayer';
import { useSystem } from '../../../hooks/useSystem';

export const ProfileSecurityPage: React.FC = observer(() => {
  const { navigate, relativeRoute } = useJourneyNavigation(Routes.PROFILE_SECURITY);
  const system = useSystem();

  React.useEffect(() => {
    system.mfaStore.loadUserMFAConfig();
  }, []);

  return (
    <ProfilePageWidget activeItemKey={Routes.PROFILE_SECURITY}>
      <S.Container>
        <PageHeadingWidget title={'Security'} />
        <S.Section>
          <S.P>
            Click the button below to change your JourneyApps password. You will be redirected to the "Change your
            password" page.
          </S.P>
          <S.Button
            label="Change password"
            type={ButtonType.SECONDARY}
            action={() => {
              window.location.assign(`${ENV.ACCOUNTS_URL}/me/password/edit`);
            }}
          />
        </S.Section>
        <S.Section>
          <S.P>
            Configure multi-factor authentication to add an additional layer of security when accessing the platform.
          </S.P>
          <S.Button
            label="Configure MFA"
            type={ButtonType.SECONDARY}
            action={async () => {
              navigate(Routes.SETUP_MFA, {});
            }}
          />
        </S.Section>
        <S.Section>
          <S.P>
            Security of our users’ data is of utmost importance at JourneyApps. We welcome the disclosure of any
            vulnerability you may find in our platform.
          </S.P>
          <S.Button
            label="Report a security issue"
            type={ButtonType.SECONDARY}
            action={() => {
              window.location.assign(`https://journeyapps.com/security-reporting/`);
            }}
          />
        </S.Section>
      </S.Container>

      <RoutesSwitch>
        <Route path={relativeRoute(Routes.SETUP_MFA)} element={<ConfigureMFADialogLayer />} />
      </RoutesSwitch>
    </ProfilePageWidget>
  );
});

namespace S {
  export const Container = styled.div`
    margin: auto;
    width: 900px;
  `;

  export const Section = styled.div`
    padding-bottom: 40px;
  `;

  export const P = styled.div`
    font-size: 14px;
    max-width: 600px;
    padding-bottom: 20px;
    color: ${(p) => p.theme.text.secondary};
  `;

  export const Button = styled(ButtonWidget)`
    width: 300px;
  `;
}
